export const RESET_CART_ISFETCHING = 'RESET_CART_ISFETCHING';
export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_FOR_SHARING_REQUEST = 'GET_CART_FOR_SHARING_REQUEST';
export const GET_CART_OBJECT_REQUESTING = 'GET_CART_OBJECT_REQUESTING';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';

export const ADD_CART_ITEM_REQUEST = 'ADD_CART_ITEM_REQUEST';
export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const REPLACE_TENDER_ON_CART_REQUEST = 'REPLACE_TENDER_ON_CART_REQUEST';

export const UPDATE_CART_REQUEST = 'UPDATE_CART_REQUEST';
export const CHARGE_CART_REQUEST = 'CHARGE_CART_REQUEST';

export const SIDE_CART_VISIBLE = 'SIDE_CART_VISIBLE';
export const SIDE_CART_NOT_VISIBLE = 'SIDE_CART_NOT_VISIBLE';

export const ADD_COUPON_REQUEST = 'ADD_COUPON_REQUEST';
export const ADD_GIFT_CARD_REQUEST = 'ADD_GIFT_CARD_REQUEST';
export const CART_IS_ITEM_BEING_ADDED = 'CART_IS_ITEM_BEING_ADDED';

export const CREATE_CART_PAYMENT_INTENT_REQUEST =
  'CREATE_CART_PAYMENT_INTENT_REQUEST';

export const ADD_LOYALTY_TENDER_REQUEST = 'ADD_LOYALTY_TENDER_REQUEST';
export const REMOVE_TENDER_REQUEST = 'REMOVE_TENDER_REQUEST';

export const VERIFY_PAYSTACK_REQUEST = 'VERIFY_PAYSTACK_REQUEST';
export const SEND_CART_TO_PAY_GATE_REQUEST = 'SEND_CART_TO_PAY_GATE_REQUEST';
export const GET_CART_FROM_PAY_GATE_REQUEST = 'GET_CART_FROM_PAY_GATE_REQUEST';

// FULLSTEAM DIGITAL WALLET CONSTANTS
export const AUTH_FULLSTEAM_WALLET_REQUESTING =
  'AUTH_FULLSTEAM_WALLET_REQUESTING';
export const AUTH_FULLSTEAM_WALLET_SUCCESS = 'AUTH_FULLSTEAM_WALLET_SUCCESS';
export const CHARGE_FULLSTEAM_WALLET_REQUESTING =
  'CHARGE_FULLSTEAM_WALLET_REQUESTING';
export const CHARGE_FULLSTEAM_WALLET_SUCCESS =
  'CHARGE_FULLSTEAM_WALLET_SUCCESS';
export const CHARGE_FULLSTEAM_WALLET_REQUEST =
  'CHARGE_FULLSTEAM_WALLET_REQUEST';
export const GET_AUTH_FULLSTEAM_WALLET = 'GET_AUTH_FULLSTEAM_WALLET';
export const RESET_FULLSTEAM_WALLET_ISFETCHING =
  'RESET_FULLSTEAM_WALLET_ISFETCHING';
